import {
    markItemJunkSucceededNotification,
    markItemsJunkSucceededNotification,
    markItemNotJunkSucceededNotification,
    markItemsNotJunkSucceededNotification,
} from './showNotificationOnMarkAsJunk.locstring.json';
import loc, { format } from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import * as undoActions from 'owa-mail-undo';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { undoAction } from 'owa-locstrings/lib/strings/undoaction.locstring.json';

import { getListViewNotificationDimensions } from 'owa-mail-layout';

/**
 * show notification on mark as junk
 * @param numberOfItems acted on for the action
 * @param mailboxes the mailboxes to undo mark as junk/not junk if the user clicks the primary button
 */
export default function showNotificationOnMarkAsJunk(
    numberOfItems: number,
    allowUndo: boolean,
    isJunkValueToSet: boolean
) {
    if (!getUserConfiguration().UserOptions.ShowNotificationBar) {
        return;
    }

    let notificationText;
    if (isJunkValueToSet) {
        notificationText =
            numberOfItems === 1
                ? loc(markItemJunkSucceededNotification)
                : format(loc(markItemsJunkSucceededNotification), numberOfItems);
    } else {
        notificationText =
            numberOfItems === 1
                ? loc(markItemNotJunkSucceededNotification)
                : format(loc(markItemsNotJunkSucceededNotification), numberOfItems);
    }
    const notificationDimensions = getListViewNotificationDimensions();

    lazyShowNotification.importAndExecute(
        'markAsJunkNotification',
        'MailModuleNotificationBarHost',
        notificationText,
        {
            icon: ControlIcons.Blocked,
            primaryActionText: allowUndo ? loc(undoAction) : null,
            allowClear: true,
            // Want 12 px of padding on either side of the notificaiton bar
            minWidth: notificationDimensions.minWidth,
            maxWidth: notificationDimensions.maxWidth,
            notificationCallback: reason => {
                if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                    undoActions.lazyUndo.importAndExecute('NotificationBar');
                }
            },
        }
    );
}
